<div class="fr-view" [innerHTML]="_textValue"></div>
